import { NextPageContextEnhanced } from "../types/page";

interface IHmacProps {
  key: string;
  msg: string;
  alg?: string;
  digest?: any;
}

export const atob64 = (input: string) => {
  return Buffer.from(input).toString("base64");
};

export const hmac = ({ alg, key, msg, digest }: IHmacProps) => {
  if (!digest) digest = "base64";
  if (!alg) alg = "sha256";
  const hmac = require("crypto").createHmac(alg, key);
  hmac.update(msg);
  return hmac.digest(digest);
};

export const rnd = (length: number | undefined) => {
  const text =
    Date.now() + ":" + Math.random() * 1000 + ":" + Math.random() * 1000;
  return require("crypto")
    .createHash("md5")
    .update(text)
    .digest("hex")
    .substring(0, length);
};

export const b64_safe = (input: string) => {
  return input.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};

export const generate_token_secret = (
  { aud, rnd, at0 }: any,
  tgt: string,
  audience_secret: any
) => {
  return b64_safe(
    hmac({ key: tgt, msg: `${aud}.${audience_secret || ""}.${rnd}.${at0}` })
  );
};

export const generate_jwt = (
  tgt: string,
  payload: { aud: string; sub?: string; rnd?: any; at0: number; exp?: number },
  header_dot_payload?: string | undefined,
  delta: number = 0
) => {
  if (!payload.sub || !payload.aud || !payload.at0) {
    console.trace("missing payload details ", payload);
    throw new Error("missing payload details");
  }
  if (!header_dot_payload) {
    const is_logged_in = payload.sub && /^[0-9]+$/.test(`${payload.sub}`);
    payload.rnd = is_logged_in ? rnd(5) : rnd(10);
    payload.exp = parseInt((Date.now() / 1000).toString()) +
        (Number(process.env.NEXT_PUBLIC_TOKEN_EXPIRED_IN_MINUTES) * 60)  + delta;
    const header = { alg: "HS256", typ: "JWT" };
    const header_b64 = b64_safe(atob64(JSON.stringify(header)));
    const payload_b64 = b64_safe(atob64(JSON.stringify(payload)));
    header_dot_payload = `${header_b64}.${payload_b64}`;
  }

  const secret = generate_token_secret(
    payload,
    tgt,
    process.env.JWT_AUDIENCE_SECRET || ""
  );
  const signature = b64_safe(hmac({ key: secret, msg: header_dot_payload }));
  let token = `${header_dot_payload}.${signature}`;
  if (token.includes("=")) {
    token = b64_safe(token);
  }
  return token;
};

export const generateTicket = (context: NextPageContextEnhanced) => {
  const at0 = parseInt(String(+new Date() / 1000));
  const deviceUUID = context.getData("deviceUUID");
  if(!deviceUUID){
    throw new Error("Calling generateTicket() without having valid deviceUUID");
  }
  console.log(
    "-> generateTicket(context)",
    `${deviceUUID}.${context.getData("source")}.${at0}`
  );
  return [
    at0,
    hmac({
      key: process.env.JWT_SALT,
      msg: `${deviceUUID}.${context.getData("source")}.${at0}`,
      digest: "hex",
    }),
  ];
};
